<template>
    <div class="container mx-auto p-6">
        <section class="my-8">
            <h1 class="text-4xl font-bold text-center font-orbitron mb-4">GPT Agents</h1>
            <p class="mx-auto max-w-2xl text-center text-lg font-roboto text-gray-700">
                Public custom GPTs we have built. The same approach applies to agents wired into your own tools and
                data.
            </p>
        </section>

        <div v-if="gpts.length" class="mb-8">
            <input type="search" placeholder="Search GPTs..." class="p-2 border border-gray-300 rounded"
                v-model="searchTerm" aria-label="Search GPT agents">
        </div>

        <p v-if="loading" class="py-12 text-center font-roboto text-gray-600">Loading agents…</p>

        <div v-else-if="filteredGPTs.length" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            <div class="bg-white rounded-lg overflow-hidden shadow-lg p-4" v-for="gpt in filteredGPTs"
                :key="gpt.permalink">
                <router-link :to="'/ai-agents/custom-gpts/' + gpt.permalink" class="block hover:no-underline">
                    <img v-lazy="gpt.image" :alt="gpt.title" class="rounded w-full mb-4">
                    <h2 class="text-lg font-bold mb-2">{{ gpt.title }}</h2>
                </router-link>
                <p class="text-gray-700 text-base mb-4">{{ gpt.short_summary }}</p>
                <router-link :to="'/ai-agents/custom-gpts/' + gpt.permalink"
                    class="text-blue-600 hover:text-blue-800 underline">Learn more</router-link>
            </div>
        </div>

        <div v-else class="py-12 text-center font-roboto">
            <p class="text-lg text-gray-700">
                {{ searchTerm ? 'No agents match that search.' : 'No agents are published right now.' }}
            </p>
            <router-link v-if="!searchTerm" to="/contact" class="btn-primary mt-6">Start a project</router-link>
        </div>

        <section v-if="gpts.length" class="my-12 border-t border-gray-200 pt-8 text-center">
            <p class="text-lg font-roboto text-gray-700">
                Need an agent that works against your own systems rather than a public one?
            </p>
            <router-link :to="{ path: '/contact', query: { service: 'AI Agent Sprint' } }" class="btn-primary mt-6">
                Start a project
            </router-link>
        </section>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'GPTsGridComponent',
    data() {
        return {
            searchTerm: '',
            gpts: [],
            loading: true,
        };
    },
    computed: {
        filteredGPTs() {
            const term = this.searchTerm.toLowerCase();
            return this.gpts.filter(gpt => (gpt.title || '').toLowerCase().includes(term));
        },
    },
    methods: {
        fetchGPTsData() {
            axios.get('/api/custom-gpts')
                .then(response => {
                    this.gpts = Array.isArray(response.data) ? response.data : [];
                })
                .catch(() => {
                    this.gpts = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    mounted() {
        this.fetchGPTsData();
    },
};
</script>
